import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=3add7fac&"
import script from "./Applications.vue?vue&type=script&lang=js&"
export * from "./Applications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports